import { ref, readonly } from "vue";

export type Log = {
  url: string;
  status: string;
  timestamp: string;
  data: unknown;
  isString?: boolean;
};

const logs = ref<Log[]>([]);

export const useLogging = () => {
  const addLog = (log: Log) => {
    if (logs.value.length >= 50) {
      logs.value.pop();
    }

    logs.value.unshift(log);
  };

  const clearLogs = () => {
    logs.value = [];
  };

  return {
    logs: readonly(logs),
    addLog,
    clearLogs,
  };
};
